/**
 * Shown when the app is loading after B2C redirect (/signin-oidc).
 * Keeps the user on this page while SsoAuthHandler processes the redirect and sets auth,
 * then SsoAuthHandler navigates to home. Do not redirect to login from here.
 */
import { useEffect } from 'react';
import { LoadingSkeleton } from '@coordio/ui/layout';

export function SignInCallbackPage() {
  useEffect(() => {
    if (import.meta.env.DEV) console.log('[SignInCallbackPage] mounted (waiting for SsoAuthHandler to set auth and navigate to /)');
  }, []);
  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center gap-2"
      data-testid="signin-callback-detail-page"
    >
      <div className="flex justify-center p-6" data-testid="signin-callback-detail-loading">
        <LoadingSkeleton rows={1} />
      </div>
      <p className="text-sm text-[var(--color-text-secondary)]">
        Signing you in...
      </p>
    </div>
  );
}
